import React from 'react'
import Input from '../UI/Input/Input'
import Button from '../UI/Button/Button'
import {updateObject, checkValidity} from '../../shared/utility'
import Fade from 'react-reveal/Fade'
import ContentForm from '../UI/ContentForm/ContentForm'
import FetchData from '../../shared/fetchData'

        const Profile = (props) => {

    const [profile, setProfile] = React.useState({
        username: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'نام کاربری'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        cellNumber: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'تلفن همراه'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        name: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'نام'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        lastname: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'نام خانوادگی'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        password: {
            elementType: 'input',
            elementConfig: {
                type: 'password',
                placeholder: 'رمز عبور'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        }
    })
    const [changeForm, setChangeForm] = React.useState(false)

    React.useEffect(() => {
        const pr = profile
        pr.username.value = props.profile.username
        pr.cellNumber.value = props.profile.cellNumber
        pr.name.value = props.profile.name
        pr.lastname.value = props.profile.lastname
        setProfile(pr)
        if (changeForm) {
            setChangeForm(false)
        } else {
            setChangeForm(true)
        }
    }, [props.profile])

    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(profile, {
            [controlName]: updateObject(profile[controlName], {
                value: event.target.value,
                valid: true
            })
        });
        setProfile(updatedControls)
    }

    const updateProfile = (event) => {
        let valid = true
        const pr = profile
        for (let key in pr) {
            if (key !== 'email') {
                if (pr[key].value == '') {
                    pr[key].valid = false
                    valid = false
                }
            }
        }
        if (!valid) {
            setProfile(pr)
            if (changeForm) {
                setChangeForm(false)
            } else {
                setChangeForm(true)
            }
        } else {
            var raw = JSON.stringify({
                "user": {
                    "id": props.profile.id,
                    "username": profile.username.value,
                    "cellNumber": profile.cellNumber.value,
                    "name": profile.name.value,
                    "lastname": profile.lastname.value,
                    "password": profile.password.value,
                    "unitId": props.profile.unitId,
                    "role": props.profile.role
                },
                "version": "mtpx001"
            })

            var url = 'management/api/v1/users/updateUser'
            FetchData(raw, url).then(response => response.json())
                    .then(result => {
                        if (result.status == 0) {
                            props.refreshInfo()
                        }
                    })
                    .catch(error => console.log(error))
        }
    }

    const formElementsArray = [];
    for (let key in profile) {
        formElementsArray.push({
            id: key,
            config: profile[key]
        })
    }

    let form = formElementsArray.map(formElement => {
        return (
                <Input
                    key={formElement.id}
                    elementType={formElement.config.elementType}
                    elementConfig={formElement.config.elementConfig}
                    value={formElement.config.value}
                    invalid={!formElement.config.valid}
                    shouldValidate={formElement.config.validation}
                    placeholder={formElement.config.placeholder}
                    errorMessage={formElement.config.errorMessage}
                    search={true}
                    col="6 mt-2"
                    changed={(event) => inputChangedHandler(event, formElement.id)} />
                );
    })
    return(
            <Fade duration={200} left cascade>
                <div>
                    <div className='row justify-content-center'>
                        <div className='tariffValue-cntnr'>
                            <ContentForm headetText='اطلاعات من'>
                                <div className='tariffValue-frm'>
                                    {form}
                                    <div className="col-12">
                                    </div>
                                    <div className="col-6 mt-3 text-center">
                                        <Button btnType="Success" clicked={props.back} >برگشت</Button>
                                    </div>
                                    <div className="col-6 mt-3 text-center">
                                        <Button btnType="Success" clicked={updateProfile} >ثبت</Button>
                                    </div>
                                </div>
                            </ContentForm>
                        </div>
                    </div>
                </div>
            </Fade>
            )
}

export default Profile